import { render, staticRenderFns } from "./FieldReassignmentAudit.vue?vue&type=template&id=d81a0c10&scoped=true&"
import script from "./FieldReassignmentAudit.vue?vue&type=script&lang=ts&"
export * from "./FieldReassignmentAudit.vue?vue&type=script&lang=ts&"
import style0 from "./FieldReassignmentAudit.vue?vue&type=style&index=0&id=d81a0c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81a0c10",
  null
  
)

export default component.exports